/* Digital Turn — ShopElmore Premium Polish v2 • 12 Sep 2026 */
(function(){
  'use strict';
  if(window.__DT_PREMIUM_POLISH_V2__) return;
  window.__DT_PREMIUM_POLISH_V2__=true;

  function injectFinalCss(){
    if(document.getElementById('dt-final-qc-v2')) return;
    var style=document.createElement('style');
    style.id='dt-final-qc-v2';
    style.textContent=`
/* Cart drawer: reserve a true image column so product copy can never overlap it */
.drawer--cart .cart__item{
  display:grid!important;
  grid-template-columns:90px minmax(0,1fr)!important;
  column-gap:12px!important;
  row-gap:0!important;
  align-items:start!important;
}
.drawer--cart .cart__item__image{
  grid-column:1!important;
  grid-row:1!important;
  position:relative!important;
  inset:auto!important;
  width:90px!important;
  min-width:90px!important;
  max-width:90px!important;
  margin:0!important;
  padding:0!important;
  transform:none!important;
  float:none!important;
}
.drawer--cart .cart__item__content{
  grid-column:2!important;
  grid-row:1!important;
  position:relative!important;
  inset:auto!important;
  width:auto!important;
  min-width:0!important;
  max-width:none!important;
  margin:0!important;
  padding:0!important;
  transform:none!important;
  float:none!important;
}
.drawer--cart .cart__item__content-inner{min-width:0!important;padding-right:24px!important}
.drawer--cart .cart__item__title{line-height:1.24!important;overflow-wrap:anywhere!important}
.drawer--cart .cart__discount{grid-column:1/-1!important}
@media(max-width:767px){
  .drawer--cart .cart__item{column-gap:12px!important}
  .drawer--cart .cart__item__title{margin-bottom:3px!important}
}

/* Hamburger: visually tighter without turning it into a cramped list */
@media(max-width:767px){
  .drawer--header .drawer__inner{width:min(86vw,336px)!important;max-width:336px!important}
  .drawer--header .drawer__head{height:52px!important;min-height:52px!important;padding:4px 8px!important}
  .drawer--header .drawer__head__content{min-height:44px!important}
  .drawer--header .drawer__logo-center{width:96px!important;max-width:96px!important}
  .drawer--header .drawer__logo-center .header__logo__link{max-width:96px!important}
  .drawer--header .drawer__close{width:33px!important;height:33px!important;border-radius:9px!important}
  .drawer--header .drawer__menu{padding:2px 7px 7px!important}
  .drawer--header .drawer__search-bar{padding:3px 1px 5px!important}
  .drawer--header .drawer__search-bar form{height:38px!important;border-radius:10px!important}
  .drawer--header .drawer__search-bar input{font-size:9.5px!important;padding-left:10px!important}
  .drawer--header .drawer__search-bar button{width:36px!important;height:36px!important;flex-basis:36px!important}
  .drawer--header .drawer__search-bar .search-icon{width:15px!important;height:15px!important}
  .drawer--header .sliderule__wrapper{border-bottom-color:rgba(17,17,17,.045)!important}
  .drawer--header .sliderow{min-height:38px!important;border-radius:8px!important}
  .drawer--header .sliderow__title{min-height:38px!important;padding:0 6px!important;gap:7px!important;border-radius:8px!important;font-size:9.7px!important;line-height:1.08!important}
  .drawer--header .dt-nav-icon{width:23px!important;height:23px!important;min-width:23px!important;border-radius:7px!important}
  .drawer--header .dt-nav-icon svg{width:11.5px!important;height:11.5px!important;max-width:11.5px!important;max-height:11.5px!important}
  .drawer--header .sliderule__chevron--right svg{width:10px!important;height:10px!important}
  .drawer--header .sliderule__wrapper--secondary .sliderow{min-height:31px!important}
  .drawer--header .sliderule__wrapper--secondary .sliderow__title{min-height:31px!important;font-size:8.7px!important;font-weight:600!important;padding:0 5px!important}
  .drawer--header .sliderule__wrapper--secondary:first-of-type{margin-top:2px!important;padding-top:2px!important}
  .drawer--header .sliderow--back{min-height:38px!important;margin-bottom:3px!important}
  .drawer--header .sliderow__back-button{width:32px!important;min-width:32px!important;height:32px!important}
  .drawer--header .drawer__bottom{padding:5px 8px 6px!important}
}

/* One polished accordion system on mobile AND desktop */
.site-footer-wrapper .dt-footer-collapsible .footer__block__title{cursor:pointer!important;user-select:none!important}
.site-footer-wrapper .dt-footer-collapsible:not(.is-open)>:not(.footer__block__title){display:none!important}
.site-footer-wrapper .dt-footer-collapsible.is-open>:not(.footer__block__title){animation:dtFooterReveal .24s cubic-bezier(.22,1,.36,1) both}
@media(min-width:768px){
  .site-footer-wrapper{padding-top:10px!important;padding-bottom:8px!important}
  .site-footer-wrapper .site-footer{padding-left:28px!important;padding-right:28px!important}
  .site-footer-wrapper .footer__blocks{display:grid!important;grid-template-columns:repeat(3,minmax(0,1fr))!important;align-items:start!important;gap:10px!important;padding:8px 0!important;margin:0!important}
  .site-footer-wrapper .footer__block.dt-footer-collapsible{width:100%!important;max-width:none!important;margin:0!important;padding:0 13px!important;border:1px solid rgba(17,17,17,.075)!important;border-radius:13px!important;background:rgba(255,255,255,.30)!important;box-shadow:0 4px 16px rgba(17,17,17,.025)!important}
  .site-footer-wrapper .dt-footer-collapsible .footer__block__title{min-height:44px!important;margin:0!important;display:flex!important;align-items:center!important;justify-content:space-between!important;gap:12px!important;font-size:11px!important;line-height:1.1!important;font-weight:750!important;letter-spacing:.01em!important}
  .site-footer-wrapper .dt-footer-collapsible .footer__block__title::after{content:"";width:7px;height:7px;flex:0 0 7px;margin-right:2px;border-right:1.5px solid currentColor;border-bottom:1.5px solid currentColor;transform:rotate(45deg) translateY(-2px);transition:transform .22s cubic-bezier(.22,1,.36,1);opacity:.64}
  .site-footer-wrapper .dt-footer-collapsible.is-open .footer__block__title::after{transform:rotate(225deg) translate(-1px,-1px)}
  .site-footer-wrapper .footer__quicklinks{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:0 16px!important;margin:0!important;padding:2px 0 11px!important}
  .site-footer-wrapper .footer__quicklinks li{margin:0!important;padding:0!important}
  .site-footer-wrapper .footer__quicklinks a{display:block!important;padding:4px 0!important;font-size:10px!important;line-height:1.2!important}
  .site-footer-wrapper .footer__block--social .socials{margin:0!important;padding:2px 0 11px!important;display:flex!important;gap:7px!important;flex-wrap:wrap!important}
  .site-footer-wrapper .footer__block--social .socials a{width:32px!important;height:32px!important;display:grid!important;place-items:center!important;border:1px solid rgba(17,17,17,.08)!important;border-radius:9px!important}
  .supporting-menu{padding-top:8px!important;padding-bottom:8px!important}
}
body.dt-footer-inview .social-fab{opacity:0!important;visibility:hidden!important;pointer-events:none!important;transform:translateY(10px)!important}
@supports(content-visibility:auto){.footer-sections{content-visibility:auto;contain-intrinsic-size:auto 160px}}
`;
    document.head.appendChild(style);
  }
  injectFinalCss();

  function onReady(fn){
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fn,{once:true});
    else fn();
  }

  function setupFooterAccordion(){
    var footer=document.querySelector('.footer-sections');
    if(!footer) return;
    var blocks=Array.prototype.slice.call(footer.querySelectorAll('.site-footer-wrapper .footer__block'));

    function closeBlock(block){
      block.classList.remove('is-open');
      var title=block.querySelector('.footer__block__title');
      if(title) title.setAttribute('aria-expanded','false');
    }

    blocks.forEach(function(block){
      if(block.dataset.dtFooterBound==='2') return;
      var title=block.querySelector('.footer__block__title');
      if(!title) return;
      block.dataset.dtFooterBound='2';
      block.classList.add('dt-footer-collapsible');
      block.classList.remove('is-open');
      title.setAttribute('role','button');
      title.setAttribute('tabindex','0');
      title.setAttribute('aria-expanded','false');

      function toggle(){
        var opening=!block.classList.contains('is-open');
        if(opening && window.matchMedia('(min-width: 768px)').matches){
          blocks.forEach(function(other){if(other!==block) closeBlock(other);});
        }
        block.classList.toggle('is-open',opening);
        title.setAttribute('aria-expanded',opening?'true':'false');
      }

      title.addEventListener('click',toggle);
      title.addEventListener('keydown',function(e){
        if(e.key==='Enter'||e.key===' '){e.preventDefault();toggle();}
      });
    });

    if('IntersectionObserver' in window&&!footer.dataset.dtFooterObserved){
      footer.dataset.dtFooterObserved='1';
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          document.body.classList.toggle('dt-footer-inview',entry.isIntersecting&&entry.intersectionRatio>0.02);
        });
      },{threshold:[0,.02,.12]});
      io.observe(footer);
    }
  }

  function tuneIconButtons(root){
    var scope=root||document;
    scope.querySelectorAll('.elmore-card__button:not(.elmore-card__button--preorder):not(.elmore-card__button--sold-out)').forEach(function(btn){
      if(!btn.getAttribute('aria-label')) btn.setAttribute('aria-label','Add to cart');
      if(!btn.getAttribute('title')) btn.setAttribute('title','Add to cart');
    });
    scope.querySelectorAll('#cart-bar .product__submit__add').forEach(function(btn){
      if(!btn.getAttribute('title')) btn.setAttribute('title','Shop now');
    });
  }

  var pendingTimer=0;
  function preferredCartToggle(){
    var mobile=window.matchMedia('(max-width: 1024px)').matches;
    return document.querySelector(mobile?'.header__mobile [data-cart-toggle]':'.header__desktop [data-cart-toggle]') || document.querySelector('[data-cart-toggle]');
  }
  function clearCartPending(){
    if(pendingTimer){clearTimeout(pendingTimer);pendingTimer=0;}
    var drawer=document.querySelector('[data-cart-drawer]');
    if(drawer) drawer.classList.remove('dt-cart-pending');
    document.querySelectorAll('.is-dt-adding').forEach(function(btn){btn.classList.remove('is-dt-adding');btn.removeAttribute('aria-busy');});
  }
  function openCartImmediately(button){
    var drawer=document.querySelector('[data-cart-drawer]');
    if(!drawer) return;
    drawer.classList.add('dt-cart-pending');
    if(button){button.classList.add('is-dt-adding');button.setAttribute('aria-busy','true');}
    if(!drawer.classList.contains('is-open')){
      var toggle=preferredCartToggle();
      if(toggle){requestAnimationFrame(function(){if(!drawer.classList.contains('is-open')){try{toggle.click();}catch(e){}}});}
    }
    pendingTimer=setTimeout(clearCartPending,4500);
  }

  document.addEventListener('theme:cart:add',function(event){
    var button=event&&event.detail&&event.detail.button?event.detail.button:null;
    openCartImmediately(button);
  },true);
  ['cart:updated','theme:cart:updated','theme:cart:change','cart:refresh'].forEach(function(name){
    document.addEventListener(name,clearCartPending,true);
  });

  function boot(){setupFooterAccordion();tuneIconButtons(document);}
  onReady(boot);
  document.addEventListener('shopify:section:load',function(e){setupFooterAccordion();tuneIconButtons(e.target||document);});
})();
